import { AppointmentListSearch, CalendarResourceAvailabilityParams } from "../types";

export const urls = {
  bulkAppointments: () => `/api/client/v1/scheduler/appointments/bulk/`,
  appointments: () => `/api/client/v1/scheduler/appointments/`,
  availabilitiesByResource: (calendarId: number) =>
    `/api/client/v1/scheduler/calendars/${calendarId}/availabilities/resources/`,
  availabilitiesByTime: (calendarId: number) =>
    `/api/client/v1/scheduler/calendars/${calendarId}/availabilities/times/`,
  calendarInfo: (calendarId: number) => `/api/client/v1/scheduler/calendars/${calendarId}/info/`,
};

export const keys = {
  all: () => ["scheduler"],
  appointments: () => [...keys.all(), "appointments"],
  appointmentLists: () => [...keys.appointments(), "list"],
  appointmentList: (search: AppointmentListSearch) => [...keys.appointmentLists(), search],
  availabilities: () => [...keys.all(), "availabilities"],
  resourceAvailabilities: () => [...keys.availabilities(), "resources"],
  timeAvailabilities: () => [...keys.availabilities(), "time"],
  resourceAvailability: (calendarId: number, params: CalendarResourceAvailabilityParams) => [
    ...keys.resourceAvailabilities(),
    calendarId,
    params,
  ],
  timeAvailability: (calendarId: number, params: CalendarResourceAvailabilityParams) => [
    ...keys.timeAvailabilities(),
    calendarId,
    params,
  ],
  calendarInfos: () => [...keys.all(), "calendar-info"],
  calendarInfo: (calendarId: number) => [...keys.calendarInfos(), calendarId],
};
